import {BreadCrumbs} from "../../../components/open/pages";

export const AdminFormsScreen = () => {
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'فرم‌ساز', url: '/admins/forms'},
            ]}/>
        </>
    );
};